import { render } from "./quoted-prices-table.vue?vue&type=template&id=532a0e38"
import script from "./quoted-prices-table.vue?vue&type=script&lang=js"
export * from "./quoted-prices-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__